<header
  class="h-24 px-2 md:px-10 flex items-center justify-between"
  [style]="{
    'background-image':
      'url(assets/svgs/auth-bg.svg), linear-gradient(90deg, #093028 0%, #237A57 100%)',
    'background-size': 'cover',
    'background-position': 'center',
  }"
>
  @if (!authService.userData()?.tenant?.tenantSettings?.businessLogoFileUrl) {
    <svg-icon
      src="assets/svgs/logo.svg"
      [svgStyle]="{ 'height.px': 31, width: 'auto' }"
    ></svg-icon>
  } @else {
    <img
      [src]="
        authService.userData()?.tenant?.tenantSettings?.businessLogoFileUrl
      "
      class="object-contain h-[31px] w-auto"
      priority
      width="31"
      height="31"
    />
  }

  <ul
    nz-menu
    nzMode="horizontal"
    nzTheme="dark"
    class="flex-1 md:flex gap-2 justify-center items-center !bg-[#fff0] border-0 hidden"
  >
    @for (nav of menuList(); track $index) {
      @if (nav.subMenuList && nav.subMenuList.length > 0) {
        <li nz-submenu [nzTitle]="titleTemplate">
          <ng-template #titleTemplate>
            <a class="flex gap-3 items-center min-w-[40px] min-h-[40px]">
              <svg-icon [src]="nav.icon"></svg-icon>
              <span>{{ nav.name }}</span>
            </a>
          </ng-template>

          <ul>
            @for (item of nav.subMenuList; track $index) {
              <li
                nz-menu-item
                [nzMatchRouterExact]="item.exact"
                nzMatchRouter
                class=""
              >
                <a
                  [routerLink]="item.link"
                  [queryParams]="item.queryParams"
                  class="flex gap-3 items-center min-w-[40px] min-h-[40px]"
                >
                  <svg-icon [src]="item.icon"></svg-icon>
                  <!-- <span class="text-2xl">.</span> -->
                  <span>{{ item.name }}</span>
                </a>
              </li>
            }
          </ul>
        </li>
      } @else {
        <li
          nz-menu-item
          [nzDanger]="nav.type === 'Danger'"
          [nzMatchRouterExact]="nav.exact"
          nzMatchRouter
        >
          <a
            [routerLink]="nav.link"
            [queryParams]="nav.queryParams"
            class="flex gap-3 items-center min-w-[40px] min-h-[40px]"
          >
            <svg-icon
              [src]="nav.icon"
              [svgStyle]="{ 'width.px': 24 }"
            ></svg-icon>
            <span>{{ nav.name }}</span>
          </a>
        </li>
      }
    }
  </ul>

  <div [ngClass]="{ 'flex items-center justify-end gap-6': true }">
    <a [routerLink]="'/admin/notifications'" class="flex items-center gap-2">
      <span class="rounded-full p-3 bg-[#26825E]">
        <svg-icon
          src="assets/svgs/bell.svg"
          [svgStyle]="{ 'width.px': 24, height: 'auto' }"
        ></svg-icon>
      </span>
    </a>

    <span>
      <a
        nz-dropdown
        nzTrigger="click"
        [nzDropdownMenu]="menu"
        class="flex items-center gap-2"
      >
        <nz-avatar
          [nzSize]="'large'"
          [nzGap]="4"
          [nzText]="abbr"
          class="border border-white bg-white text-primary-500 font-bold"
          [nzSrc]="authService.userData()?.userProfile?.user?.avatarUrl"
        ></nz-avatar>
      </a>

      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu class="w-[180px]">
          @for (item of dropdownMenuList(); track $index) {
            <li
              nz-menu-item
              [nzDanger]="item.type === 'Danger' ? true : false"
              (click)="logoutHandler(item.name, item.link[0])"
              role="button"
              class="flex items-center gap-2 py-3"
            >
              <svg-icon
                [src]="item.icon"
                [svgStyle]="{ 'width.px': 24, height: 'auto' }"
              ></svg-icon>
              <p
                class="text-base font-medium"
                [ngClass]="{ 'text-[#ff4d4f]': item.type === 'Danger' }"
              >
                {{ item.name }}
              </p>
            </li>
          }
        </ul>
      </nz-dropdown-menu>
    </span>
  </div>
</header>

<!-- *ngIf="!!authService.userData&&!hideRoutes -->
